import React, { useState } from 'react';
import './style.scss';
import { IOption } from '../Select';

export type optionType = 'default' | 'phone';
interface ISelectMenu {
    options: IOption[],
    onChange: (option: IOption) => any,
    curId?: number | string,
    optionType?: optionType,
    extraClass?: string
}
if (process.env.MAIL_APP_PLATFORM === 'h5') {
    import('./style_h5.scss')
} else {
    import('./style.scss')
}

// 目前只支持两层，后续可以查看有没兼容性（ie9）灵活性好的第三方库支持

const SelectMenu: React.FC<ISelectMenu> = ({ options, onChange, curId, extraClass, optionType="default" }) => {
    const [subOptions, setSubOptions] = useState<IOption[]>([])
    const [subOptionsParent, setSubOptionsParent] = useState<IOption | null>(null)
    const handleClickOption = (option: IOption, optionsParent?:IOption) => {
        if (option.options) {
            // 点击第一层，选择第二层的首个
            onChange({
                id: option.options[0]?.id,
                name: option?.name + '/' + option.options[0]?.name
            })
            return;
        }
        if (optionsParent) {
            onChange({
                id: option?.id,
                name: optionsParent?.name + '/' + option?.name
            })
        } else {
            onChange({
                id: option.id,
                name: option.name
            })
        }
    }
    const handleOnMouseEnter = (option: IOption) => {
        if (option.options) {
            setSubOptions(option.options);
            setSubOptionsParent(option);
        } else if (subOptions.length > 0) {
            setSubOptions([])
            setSubOptionsParent(null)
        }
    }

    const renderOption = (option: IOption) => {
        if (optionType === 'phone') {
            return (
                <div className={`select-menu-item ${curId === option.id ? 'actived' : ''}`} key={option.id + option.name} onClick={() => handleClickOption(option)}>
                    <span className="value">
                        <span className="value-id">{option.id}</span>
                        <span className="value-name">{option.name}</span>
                    </span>
                    { option.options ? <span className="arrow-icon"> </span> : null }
                </div>
            )
        }
        return (
            <div 
                className={`select-menu-item ${curId === option.id ? 'actived' : ''}`} 
                key={option.id + option.name} 
                onClick={() => handleClickOption(option)} 
                onMouseEnter={() => handleOnMouseEnter(option)}
            >
                <span className="value">{option.name}</span>
                {option.options ? <span className="arrow-icon"> </span> : null} 
            </div>
        )
    } 

    return (
        <>
            <div className={`select-menu ${extraClass ? extraClass : ''}`}>
                {
                    options.map(option => {
                        if ((!option.id && option.id !== 0) || !option.name) {
                            return null;
                        }
                        return renderOption(option)
                    })
                }
            </div>
            {subOptions.length ? (
               <div className={`select-menu select-menu-sec`}>
                   {subOptions.map((item, index) => {
                       return (
                           <div
                               className={`select-menu-item ${curId === item.id ? 'actived' : ''}`}
                               key={item.id + item.name}
                               onClick={() => handleClickOption(item, subOptionsParent as IOption)}
                           >
                               <span className="value">{item.name}</span>
                           </div>
                       )
                   })}
               </div>
            ) : null}
        </>
    )
}

export default SelectMenu;
